import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { DisableTwoFactorToUser } from './DisableTwoFactorToUser/pages/disableTwoFactorToUser/disableTwoFactorToUser.lazy';
import { Taxpayers } from './Taxpayers/pages/taxpayers/taxpayers.lazy';
import { UserAdmin } from './User/pages/userAdmin/userAdmin.lazy';
import { ChangePassword } from './UserProfile/pages/changePassword/changePassword.lazy';
import { UserProfile } from './UserProfile/pages/userProfile/userProfile.lazy';

export const AdministrationRouting = () => {
  return (
    <Routes>
      <Route
        path="user/*"
        element={
          <RouteAuth access={[Role.UsersAdmin]}>
            <UserAdmin />
          </RouteAuth>
        }
      />

      <Route
        path="taxpayers"
        element={
          <RouteAuth access={[Role.TaxpayersAdmin, Role.TaxpayersApprover]}>
            <Taxpayers />
          </RouteAuth>
        }
      />
      <Route path="user-profile" element={<UserProfile />} />
      <Route
        path="disable-tfa-to-user"
        element={
          <RouteAuth access={[Role.TfaAdmin]}>
            <DisableTwoFactorToUser />
          </RouteAuth>
        }
      />
      <Route path="change-password" element={<ChangePassword />} />
    </Routes>
  );
};
